import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from '../../utils/convergence'
import { TermLink } from '../TermLink'
import { Text } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import { useApplePaylaterLinkParams } from '../../state'

export const CashSignInTerms: FunctionComponent = () => {
  const { t } = useTranslation()
  const { extraSmallTextSize } = useCheckoutSizes()
  const withApplePaylaterParams = useApplePaylaterLinkParams()
  const components = {
    cashapplink: <TermLink key='payment-options-cash-app' color='Orca' href={withApplePaylaterParams(t('common:cashAppPrivacyPolicyUrl'))} />,
    privacy: <TermLink key='payment-options-privacy' color='Orca' href={withApplePaylaterParams(t('common:privacyPolicyUrl'))} />,
  }

  return (
    <div>
      <Text color='Gray40' size={extraSmallTextSize}>
        <Trans i18nKey='common:cashSignInTerms' components={components} />
      </Text>
    </div>
  )
}
